import React, { useEffect, useState } from "react";
import { ArrayInput, Button, SimpleFormIterator, TextInput, useNotify, useRefresh } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";
import { useWatch } from "react-hook-form";
import DeckIcon from "@mui/icons-material/Deck";
import { settings } from "app";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import FormModal from "server/components/Modals/FormModal";

const normalizeHolidays = list =>
  (list ?? [])
    .filter(item => item && (item.description || item.holidayDate))
    .map(item => ({
      description: item.description ?? "",
      holidayDate: item.holidayDate ?? null,
    }));

const HolidaysDialog = ({ label = "Празнични дни", dateFrom, dateTo }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const [initialHolidays, setInitialHolidays] = useState({ holidays: [] });
  const [hasChanges, setHasChanges] = useState(false);

  const handleOpen = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        administrationRequests.getHolidays({ dateFrom, dateTo }),
        null,
        "GET",
      );
      setInitialHolidays({ holidays: data ?? [] });
      setHasChanges(false);
    } catch (e) {
      notifyError(e);
      return false;
    }
  };

  const handleSubmit = async data => {
    const holidays = normalizeHolidays(data.holidays);
    if (holidays.length === 0) {
      notify("Моля, добавете поне един празничен ден.", { type: "warning" });
      return false;
    }
    const body = { holidays, dateFrom, dateTo };
    await dataProvider.customRequest(administrationRequests.updateHolidays(), body, "PUT");
    refresh();
    notify("Успешно промяна в празничните дни за академичната година", { type: "success" });
  };

  // Enable Save only once the holidays differ from what was loaded.
  const ChangeWatcher = () => {
    const watched = useWatch({ name: "holidays" });
    useEffect(() => {
      const current = normalizeHolidays(watched);
      const initial = normalizeHolidays(initialHolidays.holidays);
      setHasChanges(JSON.stringify(current) !== JSON.stringify(initial));
    }, [watched]);
    return null;
  };

  return (
    <FormModal
      triggerButton={
        <Button
          label={label}
          startIcon={<DeckIcon />}
        />
      }
      titleContent="Празнични дни"
      onOpen={handleOpen}
      onConfirm={handleSubmit}
      defaultValues={initialHolidays}
      confirmEnabled={hasChanges}
      saveTitle="Запази"
    >
      <ArrayInput
        source="holidays"
        label=" "
        defaultValue={[{}]}
      >
        <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
          <TextInput
            label="Име на Празничен ден"
            source="description"
          />
          <CustomDateInput
            label="Дата на Празничен ден"
            source="holidayDate"
            noTime
            required={true}
          />
        </SimpleFormIterator>
      </ArrayInput>
      <ChangeWatcher />
    </FormModal>
  );
};

export default HolidaysDialog;
